import styled from 'styled-components';
import { Modal } from '@material-ui/core';

const CouponModalStyled = styled(Modal)`
  .first_line {
    display: flex;
    align-items: center;
    .title {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #212121;
      line-height: 25px;
    }
    .close {
      margin-left: auto;
      vertical-align: middle;
    }
  }
  .search_wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 24px;
    .single-select {
      width: 240px;
    }
    .MuiTextField-root {
      width: 240px;
    }
  }
  .table {
    height: 614px;
    overflow-y: scroll;
    > div {
      padding: 0px;
      padding-bottom: 24px;
    }
  }

  .table-content {
    margin-top: 0;
  }
  .modal-btn-wrap {
    display: flex;
    flex-direction: row;
    float: right;
    gap: 16px;
  }
`;

export default CouponModalStyled;
